/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

exports.shouldUpdateScroll = ({
  routerProps: { location },
  prevRouterProps,
}) => {
  // Hash anchors are handled in src/components/Layout.tsx via scrollToElement.
  if (location.hash) {
    return false
  }

  // On any pathname change, force scroll to the top.
  const prevPath = prevRouterProps && prevRouterProps.location.pathname
  if (prevPath !== location.pathname) {
    return [0, 0]
  }

  return true
}
